/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useFetchAttendeeData from '../utils/useFetchAttendeeData';
import {
  setAttendeeGroupId,
  setQuestionUpdate,
  setLoading,
  setSelectedOptionRedux,
  setCurrentQuestionAnswered,
  setSessionStatus,
  setLeaderboardData
} from '../redux/dataSlice';
// import { useParams } from 'react-router-dom';
import OptionsList from '../common/OptionsList';
import LeaderBoard from '../common/LeaderBoard';
import socket, { joinRoom, connectSocket } from '../socket';
import ISI from '../common/ISI';
import api from '../axiosConfig';
import '../css/attendee.css';
import cltLogo from '../assets/CSLB_logo.png';

import productImg from '../assets/AndembryLogo.png';

// const debug = !!process.env.REACT_APP_DEBUG;

const Attendee = ({ monitorScreen }) => {
  const dispatch = useDispatch();

  const fetchAttendeeData = useFetchAttendeeData();
  const sessionData = useSelector((state) => state.data.sessionData);
  const attendeeSessionGroupID = useSelector((state) => state.data.attendeeSessionGroupID);
  const sessionQuestions = useSelector((state) => state.data.sessionQuestions);
  const attendeeId = useSelector((state) => state.data.attendeeId);
  const loading = useSelector((state) => state.data.loading);
  const currentQuestionIndex = useSelector((state) => state.data.currentQuestionIndex);
  const currentStep = useSelector((state) => state.data.currentStep);
  const selectedOption = useSelector((state) => state.data.selectedOption);
  const sessionStatus = useSelector((state) => state.data.sessionStatus);
  const leaderboardData = useSelector((state) => state.data.leaderboardData);
  const clientConfig = useSelector((state) => state.data.clientConfig);
  const dataLoaded = useSelector((state) => state.data.dataLoaded);

  // const { id: sessionId } = useParams();

  // State variables
  const [allowSubmit, setAllowSubmit] = useState(!monitorScreen);
  const [bottomText, setBottomText] = useState('');
  const [bottomTextClass, setBottomTextClass] = useState(null);
  const [hasSubmittedAnswer, setHasSubmittedAnswer] = useState(false);

  const questionClosedStatus = () => {
    let bottomText = '';
    let bottomTextStyle = '';
    setAllowSubmit(false);

    if (hasSubmittedAnswer) {
      if (selectedOption !== null) {
        if (sessionData.sessionQuestions[currentQuestionIndex].answerIndex === selectedOption) {
          bottomText = 'Correct Answer!';
          bottomTextStyle = 'correct-answer';
        } else {
          bottomText = 'Incorrect Answer';
          bottomTextStyle = 'wrong-answer';
        }
      }
    }

    setBottomText(bottomText);
    setBottomTextClass(bottomTextStyle);
  };

  const fetchData = async () => {
    dispatch(setLoading(true));
    try {
      await fetchAttendeeData();
    } catch (error) {
      console.error('Error fetching attendee data:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setSelectedOption = (option) => {
    dispatch(setSelectedOptionRedux(option));
  };

  const handleStatusUpdate = () => {
    if (!sessionQuestions || currentQuestionIndex == null) return;
    const answerAlreadySubmitted = sessionQuestions[currentQuestionIndex].answered;
    const exists = sessionQuestions[currentQuestionIndex].answered != null;

    setSelectedOption(exists ? answerAlreadySubmitted : null);
    setHasSubmittedAnswer(exists);

    if (currentStep === 1) {
      // Handle leaderboard
    } else if (currentStep === 2) {
      // Question closed
      questionClosedStatus();
    } else if (currentStep === 3) {
      setAllowSubmit(!exists);

      // Question opened
      // Reset submission state for the new question
      // if already answered
      // not in
      setBottomText(exists ? 'Please Wait....' : '');
      setBottomTextClass(null);
    } else if (currentStep === 4) {
      // Standby
    }
  };

  const handleNewQuestion = ({ status, questionIndex, extraContent }) => {
    // console.log("New Question")
    dispatch(setQuestionUpdate({ status, questionIndex }));
    if (extraContent?.leaderboardData && extraContent?.leaderboardData.length > 0) {
      dispatch(setLeaderboardData({ leaderboardData: extraContent.leaderboardData }));
    }
  };
  const handleSessionUpdate = ({ status }) => {
    // console.log("New Session Update")
    dispatch(setSessionStatus(status));
  };

  const handleRestartSession = ({ status }) => {
    // console.log("New Session Update")
    fetchData();
  };

  const socketConnect = () => {
    // Connect to socket
    connectSocket();

    const roomName = `attendee|${sessionData.sessionId}`;

    // Join room
    joinRoom(roomName);

    // Event listeners
    socket.on('newQuestion', handleNewQuestion);
    socket.on('sessionStatusChange', handleSessionUpdate);
    socket.on('restarted', handleRestartSession);

    // Handle reconnection in the 'connect' event
    socket.on('connect', () => {
      console.log('Socket connected');
      // Rejoin the room
      joinRoom(roomName);

      // Refresh data as needed
      fetchData();
      handleStatusUpdate();
    });

    // Optionally, handle disconnect event for logging
    socket.on('disconnect', (reason) => {
      console.log('Socket disconnected:', reason);
    });

    // Cleanup
    return () => {
      socket.off('newQuestion', handleNewQuestion);
      socket.off('sessionStatusChange', handleSessionUpdate);
      socket.off('restarted', handleRestartSession);
      socket.off('connect');
      socket.off('disconnect');
    };
  };

  useEffect(() => {
    // set monitor socket
    if (dataLoaded && monitorScreen) {
      socketConnect();
    }
  }, [dataLoaded]);

  useEffect(() => {
    // set attendee socket only after groupID is set
    if (sessionData.sessionId && attendeeSessionGroupID !== null) {
      socketConnect();

      fetchData();

      handleStatusUpdate();
    }
  }, [attendeeSessionGroupID]);

  useEffect(() => {
    handleStatusUpdate();
  }, [sessionQuestions, currentQuestionIndex, currentStep]);

  if (loading) {
    return (
      <div className="knowledge-container">
        <div className="knowledge-content">
          <h1>Loading...</h1>
        </div>
      </div>
    );
  }

  const handleGroupSubmit = async () => {
    try {
      const response = await api.post(`/attendee/selectGroup`, {
        sessionId: sessionData.sessionId,
        groupIndex: selectedOption,
        attendeeId
      });

      const { newGroup } = response.data;

      dispatch(setAttendeeGroupId(newGroup));

      // Once group is selected, join the room and refresh component
      setSelectedOption(null);
    } catch (error) {
      console.error('Error selecting group:', error);
    }
  };

  const handleSubmit = () => {
    setAllowSubmit(false);
    setHasSubmittedAnswer(true);

    console.log('UPDATING QUESTION ', currentQuestionIndex, selectedOption);
    dispatch(setCurrentQuestionAnswered({ currentQuestionIndex, answered: selectedOption }));
    console.error(sessionQuestions[currentQuestionIndex]);

    socket.emit('answerSubmitted', {
      attendeeGroupID: attendeeSessionGroupID,
      answer: selectedOption,
      currentQuestionIndex: currentQuestionIndex
    });
  };

  const renderFooter = (extendedFooter) => {
    return extendedFooter ? (
      <div className={`slanted-div ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}>
        <div className="isi-wording-wrapper">
          <div className="isi-wording-title">
            <img src={cltLogo} alt="logo" />
          </div>
          <div className="isi-wording-body">
            <p style={{ fontWeight: 'bold', marginTop: 5 }}>©2025 CSL Behring LLC.</p>
            <p>1020 First Avenue, PO Box 61501, King of Prussia, PA 19406-0901 USA</p>
            <p style={{ marginTop: 5 }}>
              <a
                href="https://www.CSLBehring.com"
                target="_blank"
                rel="noreferrer"
                style={{ fontWeight: 'bold', textDecoration: 'underline' }}
              >
                www.CSLBehring.com
              </a>
              &nbsp;&nbsp;<span style={{ fontWeight: 'bold' }}>{clientConfig.jobCode}</span>
            </p>
          </div>
        </div>
      </div>
    ) : (
      <div className={`slanted-div ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}>
        <div className={`knowledge-footer-div ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}>
          <span className="knowledge-footer-code">{clientConfig.jobCode}</span>
          <span
            className={`knowledge-footer-text ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}
          >
            {' '}
            <img src={cltLogo} alt="logo" />
          </span>
        </div>
      </div>
    );
  };

  const renderDefaultPage = ({ text, styles }, leaderboard, showWinner, extendedFooter, customFooter) => {
    const { headerWrapperStyles = null, headerStyles = null } = styles || {};

    const unbranded = clientConfig && clientConfig.customStylesClass.includes('unbranded');

    const unbrandedHeaderTextStyles = { textAlign: 'center' };

    return (
      <div className="knowledge-container">
        <div className="knowledge-header">
          {unbranded ? null : <img src={productImg} alt="Product Logo" className="knowledge-logo" />}
        </div>
        <div className="knowledge-content">
          <div className="knowledge-title-container">
            <div
              className={`knowledge-title-wrapper ${
                clientConfig.customStylesClass ? clientConfig.customStylesClass : ''
              }`}
              style={{
                '--after-size': headerWrapperStyles?.afterSize ? headerWrapperStyles.afterSize : '68%',
                '--alignCenter': headerWrapperStyles?.alignCenter || unbranded ? 'center' : 'start'
              }}
            >
              <h1
                className="knowledge-title-attendee"
                style={{ ...headerStyles, ...unbrandedHeaderTextStyles }}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
            {leaderboard && leaderboardData ? (
              <LeaderBoard
                leaderboardData={leaderboardData}
                showWinner={showWinner}
                customStylesClass={clientConfig.customStylesClass}
              />
            ) : null}
          </div>
        </div>
        {customFooter ? customFooter : renderFooter(extendedFooter)}
      </div>
    );
  };

  const renderBody = () => {
    if (!sessionData.sessionId) {
      return null;
    }

    if (sessionStatus === 3) {
      // console.log('customStyleClass:', clientConfig.customStylesClass);
      const extendedFooter = clientConfig.customStylesClass === 'gara-branded' ? false : true;
      return renderDefaultPage({ text: 'Thank You!' }, false, false, extendedFooter);
    }

    // Never show monitor group select
    if (attendeeSessionGroupID === null && !monitorScreen) {
      return (
        <div style={{ width: '100%', height: '100%' }}>
          <div className="map-div-wrapper">
            <div className={`map-div ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}>
              <div className="map-image" />
            </div>
          </div>
          <OptionsList
            title="What part of the country <br/> are you from?"
            options={sessionData.sessionGroups}
            handleSubmit={handleGroupSubmit}
            submitButtonText="Submit"
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            wrapperClass={'underlined-spans'}
            customStylesClass={clientConfig.customStylesClass}
            allowSubmit={true}
          />
        </div>
      );
    }

    if (sessionStatus === 2) {
      const finalLeaderboard = currentQuestionIndex === sessionQuestions.length - 1;
      if (currentStep === 1) {
        // Show leaderboard
        return renderDefaultPage(
          {
            text: 'Leaderboard',
            styles: {
              headerStyles: { textAlign: 'center' },
              headerWrapperStyles: { afterSize: '60%', alignCenter: true }
            }
          },
          true,
          finalLeaderboard,
          null,
          monitorScreen && clientConfig.leaderBoardFooter && (
            <div dangerouslySetInnerHTML={{ __html: clientConfig.leaderBoardFooter }} />
          )
        );
      }

      const unbranded = clientConfig && clientConfig.customStylesClass.includes('unbranded');

      const optionSelected =
        monitorScreen && currentStep === 2 ? sessionQuestions[currentQuestionIndex].answerIndex : selectedOption;

      // Show live or closed
      if ([2, 3].includes(currentStep)) {
        return (
          <OptionsList
            title={sessionQuestions[currentQuestionIndex].questionText}
            options={sessionQuestions[currentQuestionIndex].choices}
            handleSubmit={handleSubmit}
            submitButtonText="Submit"
            selectedOption={optionSelected}
            setSelectedOption={setSelectedOption}
            allowSubmit={!monitorScreen && allowSubmit}
            bottomText={bottomText}
            bottomTextClass={bottomTextClass}
            wrapperClass={''}
            showAnswer={currentStep === 2}
            answerIndex={sessionQuestions[currentQuestionIndex].answerIndex}
            optionWrapperStyle={{ paddingTop: unbranded ? '4vh' : '10vh' }}
            customStylesClass={clientConfig.customStylesClass}
          />
        );
      }
    }

    return renderDefaultPage({ text: 'Test Your <br/> Knowledge' });
  };
  // console.log('currentStep:', currentStep);

  const getAttendeeContainerStyle = () => {
    return {
      minHeight: [2, 3].includes(currentStep) || (attendeeSessionGroupID === null && !monitorScreen) ? '100vh' : 'auto'
    };
  };

  return (
    <div
      className={`attendee-container ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`}
      style={getAttendeeContainerStyle()}
    >
      <div className={`top-bar ${clientConfig.customStylesClass ? clientConfig.customStylesClass : ''}`} />

      {renderBody()}
      {!monitorScreen && !clientConfig.hideISI ? <ISI customStylesClass={clientConfig.customStylesClass} /> : null}
    </div>
  );
};

export default Attendee;
